import { Component, OnInit } from "@angular/core";
import { MessageService } from "primeng/api";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import {
  QualityGateFilter,
  QualityGateMultiSubmission,
  QualityGateSubmission,
  TransactionTagsEntry, TransactionTypeNullEntry,
} from "src/api/models";
import { QualityGateService } from "src/api/services";
import { preventLeadingSpaceKey } from "src/core/utils/input-validation.utils";
@Component({
  selector: "app-null-transaction-unprocessed",
  // imports: [],
  templateUrl: "./unprocessed.component.html",
  styleUrl: "./unprocessed.component.css",
  standalone: false,
})
export class NullTransactionUnprocessedComponent implements OnInit {
  ref!: DynamicDialogRef;
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };
  selectedTag: any[] = [];
  first = 0;
  rows = 10;
  isLoading: boolean = false;
  issuerName?: string;
  filingId?: number;
  insiderName?: string;
  unprocessedTransactionTypeNullEntries: TransactionTypeNullEntry[] = [];
  constructor(
    private _qualityGateService: QualityGateService,
    public dialogService: DialogService,
    private _messageService: MessageService
  ) {}

  ngOnInit(): void {}

  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }

  loadData(event: any) {
    if (event.first > 0 && this.paginator.pageSize != event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }
    this.paginator.pageSize = event.rows;
    this.getUnprocessedTransactionTypeNullEntries();
  }

  onExcludeClick(share: TransactionTagsEntry) {
    const submission: QualityGateSubmission = {
      qualityGateType: "Transaction_Type_null",
      missingSharesSubmission: {
        entryId: 0,
        indeterminable: false,
      },
      transactionTypeOtherSubmission: {
        entryId: 0,
        updatedTransactionType: "",
      },
      transactionTypeBuySubmission: {
        entryId: 0,
      },
      missingSecurityBreakDownSubmission: {
        entryId: 0,
      },
      aggregateSharesValidationSubmission: {
        entryId: 0,
        indeterminable: false,
      },
      transactionTagsSubmission: {
        entryId: 0,
      },
      planActionSubmission: {
        entryId: 0,
      },
      adoptionMissingDatesSubmission: {
        entryId: 0,
      },
      transactionTypeNullSubmission: {
        entryId: share.entryId ?? 0,
      }
    };

    this._qualityGateService.submit(submission).subscribe({
      next: (response) => {
        this._messageService.add({
          severity: "success",
          summary: "Submission Successful",
          detail: "The record has been excluded successfully.",
        });
        this.getUnprocessedTransactionTypeNullEntries();
      },
      error: (err) => {
        this._messageService.add({
          severity: "error",
          summary: "Submission Failed",
          detail: err?.error?.message || "An error occurred while submitting.",
        });
      },
    });
  }

  onSearch() {
        const fid = String(this.filingId ?? '').trim();
  if (fid && !/^\d+$/.test(fid)) {
    return;
  }
    this.first = 0;
    this.paginator.pageNumber = 1;
    this.getUnprocessedTransactionTypeNullEntries();
  }
   preventSpaceKey(event: KeyboardEvent): void {
      preventLeadingSpaceKey(event);
    }

  getUnprocessedTransactionTypeNullEntries() {
    const params: QualityGateFilter = {
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      processStatus: "UNPROCESSED",
      qualityGateType: "Transaction_Type_null",
      issuerName: this.issuerName,
      insiderName: this.insiderName,
      filingId: this.filingId,
    };
    this.isLoading = true;
    this._qualityGateService.view(params).subscribe({
      next: (value) => {
        this.unprocessedTransactionTypeNullEntries = value.transactionTypeNullEntries ?? [];
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.paginator.totalCount =
          this.unprocessedTransactionTypeNullEntries?.[0]?.totalCount ?? 0;
        this.isLoading = false;
      },
    });
  }
  onGroupExclusionClick() {
    const entryIds = this.selectedTag
      .filter((share) => share.entryId !== undefined)
      .map((share) => share.entryId);
    const submission: QualityGateMultiSubmission = {
      entryIds: entryIds,
      indeterminable: true,
      qualityGateType: "Transaction_Type_null",
    };

    this._qualityGateService.multiSubmission(submission).subscribe({
      next: (response) => {
        this._messageService.add({
          severity: "success",
          summary: "Submission Successful",
          detail: "The record has been excluded successfully.",
        });
        this.selectedTag = [];
        this.getUnprocessedTransactionTypeNullEntries();
      },
      error: (err) => {
        this._messageService.add({
          severity: "error",
          summary: "Submission Failed",
          detail: err?.error?.message || "An error occurred while submitting.",
        });
      },
    });
  }
}
